const addLoaderOverlayOpacity = (loader: Element | null) => {
  if (loader?.hasAttribute('overlayopacity')) {
    const overlayOpacityValue = loader.getAttribute('overlayopacity');
    const parentElement = loader.parentElement;
    parentElement?.classList.add('overlay-opacity-' + overlayOpacityValue);
  }
};

const removeLoaderOverlayOpacity = (loader: Element | null) => {
  if (loader?.hasAttribute('overlayopacity')) {
    const overlayOpacityValue = loader.getAttribute('overlayopacity');
    const parentElement = loader.parentElement;
    parentElement?.classList.remove('overlay-opacity-' + overlayOpacityValue);
  }
};

export const openLoader = (loaderSelector: string) => {
  document.querySelector(`${loaderSelector}`)?.classList.remove('hide');
  const loader = document.querySelector('.cmp-loader');
  addLoaderOverlayOpacity(loader);
};

export const closeLoader = (loaderSelector: string) => {
  document.querySelector(`${loaderSelector}`)?.classList.add('hide');
  const loader = document.querySelector('.cmp-loader');
  removeLoaderOverlayOpacity(loader);
};

export const openForceLoader = () => {
  document.querySelector('body')?.classList.add('force-loader');
};

export const closeForceLoader = () => {
  document.querySelector('body')?.classList.remove('force-loader');
};

//only to test it
closeLoader('.loader');
